import { apiPost } from '..';

interface SWGenerateResult {
  code: number;
  location: string;
}

export function generateCsvReport(propertyId: string): Promise<SWGenerateResult> {
  return apiPost(`/ext/sw_export/${propertyId}/generate`);
}
